declare type AvailableCurrencies =
  | 'Euro'
  | 'Franc'
  | 'Pound'
  | 'Swedish_Krone'
  | 'Danish_Krone'
  | 'Norwegian_Krone'
  | 'Dollar';
export const allCurrrencies: string[] = ['EUR', 'CHF', 'GBP', 'SEK', 'DKK', 'NOK', 'USD'];
export const currencies: Record<AvailableCurrencies, string> = {
  Euro: 'EUR',
  Franc: 'CHF',
  Pound: 'GBP',
  Swedish_Krone: 'SEK',
  Danish_Krone: 'DKK',
  Norwegian_Krone: 'NOK',
  Dollar: 'USD'
};
